import { bootstrapApplication } from '@angular/platform-browser';
import { APP_CONFIG } from './app/app.config';
import { AppComponent } from './app/app.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import * as Sentry from "@sentry/angular";
import { Router } from '@angular/router';
import { ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { GlobalErrorHandler } from './app/shared/utils/globalErrorHandler';

  fetch('assets/js/config.json')
  .then(response => response.json())
  .then(config => {
    bootstrapApplication(AppComponent, {
      providers: [
        provideZoneChangeDetection(),...APP_CONFIG.providers,
        { provide: 'APP_CONFIG', useValue: config },
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: ErrorHandler, useClass: GlobalErrorHandler},
        { provide: Sentry.TraceService, deps: [Router] },
      ]
    })
    .catch(err => console.error(err))
  });